module.exports = __webpack_public_path__ + "static/media/phd.58b46463.png";